import React, { useMemo, useEffect, useState } from "react";
import MultiSelectInput from "../../common/multi-select-input";
import { DatePicker, Input } from "antd";
import dayjs from "dayjs";
import FileUpload from "../UploadFileNewComponent/UploadFile";
import styles from "./Styles/MoreDetails.module.css";
import FailureIcon from "../../icons/failure-icon";
import Text from "../../common/typography/text";

export default function MoreDetails({ formData, setFormData }) {
  const [uploadedFiles, setUploadedFiles] = useState([]);
  // const [regions, setRegions] = useState([
  //   "North Atlantic",
  //   "South Atlantic",
  //   "Pacific West",
  //   "South Central",
  //   "North Central",
  //   "Test Regions",
  //   "Test Regions 2",
  // ]);

  // const [selectedRegions, setSelectedRegions] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);

  const [localWounds, setLocalWounds] = useState(
    formData.wounds?.length
      ? formData.wounds
      : [{ id: Date.now(), type: "", size: "", cpt: "", icd: "", saved: false }]
  );

  const updateWound = (id, field, value) => {
    const updated = localWounds.map((w) =>
      w.id === id ? { ...w, [field]: value } : w
    );
    setLocalWounds(updated);
    setFormData({ ...formData, wounds: updated });
  };

  const saveRow = (id) => {
    const updated = localWounds.map((w) =>
      w.id === id ? { ...w, saved: true } : w
    );
    updated.push({
      id: Date.now(),
      type: "",
      size: "",
      cpt: "",
      icd: "",
      saved: false,
    });
    setLocalWounds(updated);
    // setFormData({ ...formData, wounds: updated });
  };

  const removeWound = (id) => {
    const updated = localWounds.filter((w) => w.id !== id);
    setLocalWounds(updated);
    setFormData({ ...formData, wounds: updated });
  };

  const normalizeProductOption = (opt) => {
    if (!opt) return null;
    if (typeof opt === "string") {
      return { label: opt, value: opt };
    }
    const label =
      opt.label ?? opt.ProductGroupName ?? opt.name ?? opt.value ?? "";
    const value =
      opt.value ?? opt.ProductGroupID ?? opt.id ?? opt.label ?? "";
    if (label === "" || value === "") return null;
    return { ...opt, label, value };
  };

  const normalizeProductOptions = (options = []) =>
    options.map(normalizeProductOption).filter(Boolean);

  const optionValuesKey = (options = []) =>
    options.map((opt) => String(opt.value)).sort().join("|");

  const productOptions = useMemo(
    () => normalizeProductOptions(formData.productGroupOptions || []),
    [formData.productGroupOptions]
  );

  useEffect(() => {
    const normalizedSelected = normalizeProductOptions(
      formData.selectedProducts || []
    );
    if (
      optionValuesKey(selectedProducts) !==
      optionValuesKey(normalizedSelected)
    ) {
      setSelectedProducts(normalizedSelected);
    }
  }, [formData.selectedProducts]);

  useEffect(() => {
    if (!productOptions.length && selectedProducts.length) {
      setSelectedProducts([]);
      setFormData((prev) => ({ ...prev, selectedProducts: [] }));
      return;
    }
    if (!productOptions.length) return;
    const optionValueSet = new Set(productOptions.map((o) => String(o.value)));
    const filteredSelected = selectedProducts.filter((s) =>
      optionValueSet.has(String(s.value))
    );
    if (
      optionValuesKey(selectedProducts) !== optionValuesKey(filteredSelected)
    ) {
      setSelectedProducts(filteredSelected);
      setFormData((prev) => ({ ...prev, selectedProducts: filteredSelected }));
    }
  }, [productOptions]);

  const setSelectedProductsHandler = (newSelected) => {
    const normalized = normalizeProductOptions(newSelected || []);
    setSelectedProducts(normalized);
    setFormData((prev) => ({ ...prev, selectedProducts: normalized }));
  };

  const selectAllProducts = () => {
    setSelectedProducts(productOptions);
    setFormData((prev) => ({ ...prev, selectedProducts: productOptions }));
  }

  // const setSelectedRegionsHandler = (newSelected) => {
  //   setSelectedRegions(newSelected);
  //   setFormData({ ...formData, selectedRegions: newSelected });
  // };

  // const selectAllRegions = () => {
  //   const allOptions = regions.map((r) => ({ label: r, value: r }));
  //   setSelectedRegions(allOptions);
  //   setFormData({ ...formData, selectedRegions: allOptions });
  // };

  return (
    <div className={styles.container}>
      <h2>MORE DETAILS</h2>

      {/* --- WOUND TABLE --- */}
      <div className={styles.table}>
        {/* --- Table Header --- */}
        <div className={styles.headerRow}>
          <div>No.</div>
          <div>Wound Type</div>
          <div>Wound Size</div>
          <div>Application CPT</div>
          <div>ICD-10 Diagnosis Code</div>
          <div>Action</div>
        </div>

        {/* --- Table Rows --- */}
        {localWounds.map((wound, i) => (
          <div key={wound.id} className={styles.row}>
            <span className={styles.index}>{i + 1}</span>

            <input
              className={styles.input}
              placeholder="Wound Type"
              value={wound.type}
              onChange={(e) => updateWound(wound.id, "type", e.target.value)}
              disabled={wound.saved}
            />
            <input
              className={styles.input}
              placeholder="Size"
              value={wound.size}
              onChange={(e) => updateWound(wound.id, "size", e.target.value)}
              disabled={wound.saved}
            />
            <input
              className={styles.input}
              placeholder="CPT"
              value={wound.cpt}
              onChange={(e) => updateWound(wound.id, "cpt", e.target.value)}
              disabled={wound.saved}
            />
            <input
              className={styles.input}
              placeholder="ICD-10"
              value={wound.icd}
              onChange={(e) => updateWound(wound.id, "icd", e.target.value)}
              disabled={wound.saved}
            />

            <div className={styles.actionCell}>
              {wound.saved ? (
                <button
                  className={styles.deleteBtn}
                  onClick={() => removeWound(wound.id)}
                >
                  ×
                </button>
              ) : (
                <button
                  className={styles.saveBtn}
                  onClick={() => saveRow(wound.id)}
                >
                  <div className={styles.saveIcon}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        d="M7.2002 9.59961H12.0002"
                        stroke="#5ABA42"
                        stroke-width="1.6"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M9.6001 7.19922V11.9992"
                        stroke="#5ABA42"
                        stroke-width="1.6"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M2.3999 9.60039C2.3999 3.67119 3.6707 2.40039 9.5999 2.40039C15.5291 2.40039 16.7999 3.67119 16.7999 9.60039C16.7999 15.5296 15.5291 16.8004 9.5999 16.8004C3.6707 16.8004 2.3999 15.5296 2.3999 9.60039Z"
                        stroke="#5ABA42"
                        stroke-width="1.6"
                      />
                    </svg>
                  </div>
                </button>
              )}
            </div>
          </div>
        ))}
      </div>

      {/* --- Product SELECTOR --- */}
      {(productOptions && productOptions.length > 0) ?
        <div className={styles.regionsSection}>
          <p>
            Select all products you would like to submit this IVR for{" "}
            <span style={{ color: "red" }}>*</span>
          </p>
          <MultiSelectInput
            type="NonAsync"
            placeholder="Select Products"
            value={selectedProducts}
            setValue={setSelectedProductsHandler}
            options={productOptions}
            labelKey="label"
            labelValue="value"
          />
          {/* <button className={styles.selectAllBtn} onClick={selectAllRegions}> */}
          <button className={styles.selectAllBtn} onClick={selectAllProducts}>
            <span> Select All</span>
          </button>
        </div> :
        <div className="modal-warning-container-ivr">
          <FailureIcon
            className="warning-icon-container"
            width={16}
            height={16}
          />
          <Text>
            The account you are submitting this IVR for does not have any products added or approved to the product catalog. Please mention the products you would like to submit for.
          </Text>
          <div className={styles.formField}>
            <label>
              Products Requested <span style={{ color: "red" }}> *</span>
            </label>
            <p className='input-subtitle'>Please specify the products you would like to submit for.</p>
            <Input
              name="unavailableProductsRequested"
              value={formData.unavailableProductsRequested}
              onChange={(e) =>
                setFormData({ ...formData, unavailableProductsRequested: e.target.value })
              }
            />
          </div>
        </div>
      }

      <div className={styles.frame}>
        {/* /* --- DATE --- */} 
          <div className={styles.dateRow}>
            <label>Date of Procedure</label>
            <DatePicker
              format="MM-DD-YYYY"
              value={formData.procedureDate ? dayjs(formData.procedureDate) : null}
              onChange={(date, dateString) =>
                setFormData({ ...formData, procedureDate: dateString })
              }
              style={{
                width: "100%",
                height: 33,
                borderRadius: 6,
              }}
              disabledDate={(current) => current && current < dayjs().startOf('day')}
            />
            <Text variant="tinyText" color="lightText">MM-DD-YYYY</Text>

          </div>

          <div className={styles.questions}>
            {[
              {
                key: "inSNF",
                label: "Is the patient currently residing in SNF?",
              },
              {
                key: "surgicalGlobal",
                label: "Is the patient under a surgical global period?",
              },
              { key: "inHospice", label: "Is the patient currently in hospice?" },
            ].map((q, idx) => (
              <div key={idx} className={styles.questionRow}>
                <span>{q.label}</span>
                <div className={styles.ansFrame}>
            <label>
              <input
                type="radio"
                name={q.key}
                value="Yes"
                checked={formData[q.key] === "Yes"}
                onChange={(e) =>
                  setFormData({ ...formData, [q.key]: e.target.value })
                }
              />{" "}
              <span>Yes</span>
            </label>
            <label>
              <input
                type="radio"
                name={q.key}
                value="No"
                checked={formData[q.key] === "No"}
                onChange={(e) =>
                  setFormData({ ...formData, [q.key]: e.target.value })
                }
              />{" "}
              <span>No</span>
            </label>
                </div>
              </div>
            ))}
          </div>
              </div>


              {/* --- FILE UPLOAD --- */}
      <div className={styles.fileUploadSection}>
        <label className={styles.label}>Patient's Clinical Record</label>

        <FileUpload
          uploadedFiles={uploadedFiles}
          setUploadedFiles={(files) => {
            setUploadedFiles(files);
            setFormData({ ...formData, patientsClinicalRecord: files });
          }}
          // screen="MoreDetails"
          // formData={formData}
          // setFormData={setFormData}
        />
      </div>

      {/* --- SIGNATURE --- */}
      <div className={styles.signature}>
        <div className={styles.sigHeader}>
          <h2>SIGNATURE</h2>
          <p>
            By signing below, I certify that I have received the necessary
            patient authorization to release the medical and/or other patient
            information referenced on the form relating to the above-referenced
            patient. This information is for verifying insurance coverage,
            seeking reimbursement, and the sole purpose of claim support.
          </p>
        </div>

        <div className={styles.formField}>
          <label>
            Signature <span style={{ color: "red" }}> *</span>
          </label>
          <Input
            name="signature"
            value={formData.signature}
            onChange={(e) =>
              setFormData({ ...formData, signature: e.target.value })
            }
          />
          <p>
            Please type your full name. This will serve as your e-signature.
          </p>
        </div>
      </div>
    </div>
  );
}
